import { styled } from '../../../config'

export const Root = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px'
})
